// Background transition logic for products carousel
class ProductsCarouselBackground {
  constructor(element) {
    this.element = element;
    this.currentBackground = null;
    this.bgOverlay = null;
    this.transitionEndHandler = null;
  }

  applyBackground(bgValue) {
    if (!bgValue || bgValue.trim() === '') return;

    const trimmedBg = bgValue.trim();
    if (this.currentBackground === trimmedBg) return;

    const hexColorPattern = /^#([0-9A-Fa-f]{6})#([0-9A-Fa-f]{6})$/;
    const match = trimmedBg.match(hexColorPattern);

    if (this.transitionEndHandler && this.bgOverlay) {
      this.bgOverlay.removeEventListener('transitionend', this.transitionEndHandler);
      this.transitionEndHandler = null;
    }

    if (!this.bgOverlay) {
      this.bgOverlay = document.createElement('div');
      this.bgOverlay.className = 'products-carousel__bg-overlay';
      this.bgOverlay.style.position = 'absolute';
      this.bgOverlay.style.top = '0';
      this.bgOverlay.style.left = '0';
      this.bgOverlay.style.right = '0';
      this.bgOverlay.style.bottom = '0';
      this.bgOverlay.style.width = '100%';
      this.bgOverlay.style.height = '100%';
      this.bgOverlay.style.pointerEvents = 'none';
      this.bgOverlay.style.zIndex = '-1';
      this.bgOverlay.style.transition = 'opacity 1.5s ease-in-out';
      this.bgOverlay.style.opacity = '0';
      this.element.insertBefore(this.bgOverlay, this.element.firstChild);
    } else {
      this.bgOverlay.style.transition = 'none';
      this.bgOverlay.style.opacity = '0';
      this.bgOverlay.offsetHeight;
      this.bgOverlay.style.transition = 'opacity 1.5s ease-in-out';
    }

    if (match) {
      const color1 = `#${match[1]}`;
      const color2 = `#${match[2]}`;
      this.bgOverlay.style.background = `linear-gradient(to bottom, ${color1}, ${color2})`;
    } else {
      this.bgOverlay.style.background = trimmedBg;
    }

    if (this.currentBackground === null) {
      if (match) {
        const color1 = `#${match[1]}`;
        const color2 = `#${match[2]}`;
        this.element.style.background = `linear-gradient(to bottom, ${color1}, ${color2})`;
      } else {
        this.element.style.background = trimmedBg;
      }
      this.bgOverlay.style.opacity = '0';
      this.currentBackground = trimmedBg;
      return;
    }

    const finalBackground = match ? `linear-gradient(to bottom, #${match[1]}, #${match[2]})` : trimmedBg;

    this.transitionEndHandler = () => {
      this.element.style.background = finalBackground;
      this.bgOverlay.style.opacity = '0';
      this.transitionEndHandler = null;
    };

    this.bgOverlay.addEventListener('transitionend', this.transitionEndHandler, { once: true });

    requestAnimationFrame(() => {
      this.bgOverlay.style.opacity = '1';
    });

    this.currentBackground = trimmedBg;
  }

  updateFromSlide(slideElement) {
    if (!slideElement) return;
    const background = slideElement.getAttribute('data-product-background');
    if (background) {
      this.applyBackground(background);
    }
  }
}

// Expose class globally for use in inline scripts
window.ProductsCarouselBackground = ProductsCarouselBackground;
